"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var verticalSelectList_1 = require("spry-react/VerticalSelectList/verticalSelectList");
var classNames = require("classnames");
require("./editableGrid.less");
var editableGridStyles = require("./editableGridStyles");
var link_1 = require("spry-react/Link/link");
var idGenerator_1 = require("spry-react/utils/idGenerator");
function EditableGridHeader(props) {
    var classes = classNames("editable-grid-header", { "required": props.required });
    return (React.createElement("div", { className: "pure-u-" + props.size },
        React.createElement("h4", { className: classes, style: props.alignment != null ? { textAlign: props.alignment } : {} }, props.label)));
}
var EditableGrid = /** @class */ (function (_super) {
    __extends(EditableGrid, _super);
    function EditableGrid() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.id = idGenerator_1.GenerateId();
        return _this;
    }
    EditableGrid.prototype.render = function () {
        var _this = this;
        var _a = this.props, heading = _a.heading, headers = _a.headers, rows = _a.rows, emptyMessageText = _a.emptyMessageText;
        var buttons = this.isSingleButtonProps(this.props)
            ? [this.props.addButton]
            : this.props.addButtons;
        return React.createElement("div", { className: "grid-section l-box", id: this.id, role: "group", "aria-labelledby": this.id + "-heading" },
            heading &&
                React.createElement("h3", { className: "grid-section-title l-box-vb-1-2x", id: this.id + "-heading" }, heading),
            rows.length > 0
                ? React.createElement(React.Fragment, null,
                    headers && headers.length &&
                        React.createElement("div", { className: 'pure-g' },
                            React.createElement("div", { className: 'pure-u-23-24' },
                                React.createElement("div", { className: 'pure-g', style: { alignItems: 'flex-end' } }, headers.map(function (headerProps, i) { return React.createElement(EditableGridHeader, __assign({}, headerProps, { key: "header-" + i })); }))),
                            React.createElement("div", { className: 'pure-u-1-24' })),
                    rows.map(function (row) { return (React.createElement("div", { className: 'pure-g', key: "row-" + row.key, id: EditableGrid.getRowId(_this.id, row.key) },
                        React.createElement("div", { className: 'pure-u-23-24' },
                            React.createElement("div", { className: 'pure-g' }, row.cells.map(function (cell, i) {
                                var cellClasses = classNames("pure-u-" + cell.size, 'field', 'field-v-0');
                                return (React.createElement("div", { className: cellClasses, key: "cell-" + i }, cell.element));
                            }))),
                        React.createElement("div", { className: 'pure-u-1-24', style: { display: 'flex', alignItems: 'center', justifyContent: 'center' } },
                            React.createElement(EditableGridDeleteButton, { title: row.deleteButton.title, disabled: row.deleteButton.disabled, onClick: function () { return row.deleteButton.onClick().then(function () { return _this.focusFirstAddButton(); }); } })))); }))
                : React.createElement("div", { className: "notentered" }, emptyMessageText),
            React.createElement("div", { className: "pure-g l-box-vt", id: EditableGrid.getAddButtonsId(this.id) }, buttons.map(function (button, i) {
                var customSize = button.size ? "pure-u-" + button.size : null;
                var buttonClasses = classNames(customSize, {
                    'pure-u-1-4': !button.size,
                    'l-box-hl-1-2x': i > 0
                });
                return (React.createElement("div", { className: buttonClasses, key: "addButton-" + i },
                    React.createElement(verticalSelectList_1.VerticalSelectListButton, { disabled: button.disabled, label: button.label, onClick: function () { return button.onClick().then(function (key) { return _this.focusRow(key); }); } })));
            })));
    };
    EditableGrid.getRowId = function (gridId, key) {
        return gridId + "-row-" + key;
    };
    EditableGrid.getAddButtonsId = function (gridId) {
        return gridId + "-addButtons";
    };
    EditableGrid.prototype.focusRow = function (key) {
        $(":focusable", "#" + EditableGrid.getRowId(this.id, key)).first().focus();
    };
    EditableGrid.prototype.focusFirstAddButton = function () {
        $(":focusable", "#" + EditableGrid.getAddButtonsId(this.id)).first().focus();
    };
    EditableGrid.prototype.isSingleButtonProps = function (testProps) {
        return testProps.addButton !== undefined;
    };
    return EditableGrid;
}(React.Component));
exports.EditableGrid = EditableGrid;
var EditableGridDeleteButton = /** @class */ (function (_super) {
    __extends(EditableGridDeleteButton, _super);
    function EditableGridDeleteButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EditableGridDeleteButton.prototype.render = function () {
        return React.createElement(link_1.Link, { className: editableGridStyles.editableGridDeleteItem, disabled: this.props.disabled, title: this.props.title, onClick: this.props.onClick });
    };
    return EditableGridDeleteButton;
}(React.Component));
exports.EditableGridDeleteButton = EditableGridDeleteButton;
